import React from 'react';
import { Link } from 'react-router-dom';
import { DashboardLayout } from '../../components/DashboardLayout';
import { User, Mail, Phone, MapPin, Calendar, Shield, Edit, CheckCircle, AlertCircle } from 'lucide-react';
export function PersonalProfilePage() {
  const navItems = [{
    label: 'Dashboard',
    icon: User,
    path: '/dashboard'
  }, {
    label: 'Profile',
    icon: User,
    path: '/profile'
  }];
  const userProfile = {
    name: 'Amit Sharma',
    email: 'amit.sharma@example.com',
    phone: '+91 98765 43210',
    location: 'Pune, Maharashtra',
    joinedDate: '2023-06-15',
    verificationStatus: 'verified',
    profileCompleteness: 85
  };
  const verificationChecklist = [{
    item: 'Email Verified',
    status: 'complete',
    icon: CheckCircle,
    color: 'text-green-600'
  }, {
    item: 'Phone Verified',
    status: 'complete',
    icon: CheckCircle,
    color: 'text-green-600'
  }, {
    item: 'Identity Documents',
    status: 'complete',
    icon: CheckCircle,
    color: 'text-green-600'
  }, {
    item: 'Address Proof',
    status: 'pending',
    icon: AlertCircle,
    color: 'text-yellow-600'
  }, {
    item: 'Bank Account',
    status: 'complete',
    icon: CheckCircle,
    color: 'text-green-600'
  }];
  const transactionHistory = [{
    id: 1,
    type: 'Purchase',
    property: 'Plot in Hinjewadi',
    date: '2024-01-15',
    amount: '₹45 Lakhs',
    status: 'Completed'
  }, {
    id: 2,
    type: 'Inquiry',
    property: 'Land in Baner',
    date: '2024-01-10',
    amount: '-',
    status: 'Active'
  }];
  return <DashboardLayout title="Personal Profile" navItems={navItems} userInitials="AS" data-id="element-5357">
      <div className="max-w-4xl mx-auto" data-id="element-5358">
        <div className="flex items-center justify-between mb-8" data-id="element-5359">
          <h1 className="text-2xl font-bold" data-id="element-5360">Personal Profile</h1>
          <Link to="/profile/edit" className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5361">
            <Edit className="w-4 h-4" data-id="element-5362" />
            Edit Profile
          </Link>
        </div>

        {/* Profile Completeness */}
        <div className="bg-white border border-gray-300 p-6 mb-6" data-id="element-5363">
          <div className="flex items-center justify-between mb-3" data-id="element-5364">
            <h2 className="font-bold" data-id="element-5365">Profile Completeness</h2>
            <span className="text-2xl font-bold text-blue-600" data-id="element-5366">
              {userProfile.profileCompleteness}%
            </span>
          </div>
          <div className="h-3 bg-gray-200 rounded-full overflow-hidden" data-id="element-5367">
            <div className="h-full bg-blue-600 transition-all duration-300" style={{
            width: `${userProfile.profileCompleteness}%`
          }} data-id="element-5368"></div>
          </div>
          <p className="text-xs text-gray-500 mt-2" data-id="element-5369">
            Complete your profile to unlock all features and increase trust with
            sellers
          </p>
        </div>

        {/* Verification Status */}
        <div className="bg-white border border-gray-300 p-6 mb-6" data-id="element-5370">
          <div className="flex items-center gap-3 mb-4" data-id="element-5371">
            <Shield className="w-6 h-6 text-green-600" data-id="element-5372" />
            <div data-id="element-5373">
              <h2 className="font-bold" data-id="element-5374">Verification Status</h2>
              <p className="text-sm text-gray-600" data-id="element-5375">
                {userProfile.verificationStatus === 'verified' && 'Your profile is fully verified'}
                {userProfile.verificationStatus === 'otp-verified' && 'Basic verification complete'}
                {userProfile.verificationStatus === 'unverified' && 'Verification pending'}
              </p>
            </div>
            {userProfile.verificationStatus === 'verified' && <span className="ml-auto px-3 py-1 bg-green-50 text-green-700 text-xs font-bold border border-green-200 rounded" data-id="element-5376">
                VERIFIED
              </span>}
          </div>

          <div className="space-y-3" data-id="element-5377">
            {verificationChecklist.map((item, i) => <div key={i} className="flex items-center gap-3 p-3 border border-gray-200" data-id="element-5378">
                <item.icon className={`w-5 h-5 ${item.color}`} data-id="element-5379" />
                <span className="flex-1 text-sm font-medium" data-id="element-5380">{item.item}</span>
                <span className="text-xs text-gray-500" data-id="element-5381">
                  {item.status === 'complete' ? 'Verified' : 'Pending'}
                </span>
              </div>)}
          </div>
        </div>

        {/* Basic Information */}
        <div className="bg-white border border-gray-300 p-6 mb-6" data-id="element-5382">
          <h2 className="font-bold mb-4" data-id="element-5383">Basic Information</h2>
          <div className="space-y-4" data-id="element-5384">
            <div className="flex items-center gap-3 p-3 border border-gray-200" data-id="element-5385">
              <User className="w-5 h-5 text-gray-400" data-id="element-5386" />
              <div className="flex-1" data-id="element-5387">
                <p className="text-xs text-gray-500" data-id="element-5388">Full Name</p>
                <p className="font-medium" data-id="element-5389">{userProfile.name}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-3 border border-gray-200" data-id="element-5390">
              <Mail className="w-5 h-5 text-gray-400" data-id="element-5391" />
              <div className="flex-1" data-id="element-5392">
                <p className="text-xs text-gray-500" data-id="element-5393">Email Address</p>
                <p className="font-medium" data-id="element-5394">{userProfile.email}</p>
              </div>
              <CheckCircle className="w-4 h-4 text-green-600" data-id="element-5395" />
            </div>

            <div className="flex items-center gap-3 p-3 border border-gray-200" data-id="element-5396">
              <Phone className="w-5 h-5 text-gray-400" data-id="element-5397" />
              <div className="flex-1" data-id="element-5398">
                <p className="text-xs text-gray-500" data-id="element-5399">Phone Number</p>
                <p className="font-medium" data-id="element-5400">{userProfile.phone}</p>
              </div>
              <CheckCircle className="w-4 h-4 text-green-600" data-id="element-5401" />
            </div>

            <div className="flex items-center gap-3 p-3 border border-gray-200" data-id="element-5402">
              <MapPin className="w-5 h-5 text-gray-400" data-id="element-5403" />
              <div className="flex-1" data-id="element-5404">
                <p className="text-xs text-gray-500" data-id="element-5405">Location</p>
                <p className="font-medium" data-id="element-5406">{userProfile.location}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-3 border border-gray-200" data-id="element-5407">
              <Calendar className="w-5 h-5 text-gray-400" data-id="element-5408" />
              <div className="flex-1" data-id="element-5409">
                <p className="text-xs text-gray-500" data-id="element-5410">Member Since</p>
                <p className="font-medium" data-id="element-5411">{userProfile.joinedDate}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Transaction History */}
        <div className="bg-white border border-gray-300 p-6" data-id="element-5412">
          <h2 className="font-bold mb-4" data-id="element-5413">Recent Activity</h2>
          <div className="space-y-3" data-id="element-5414">
            {transactionHistory.map(transaction => <div key={transaction.id} className="flex items-center justify-between p-4 border border-gray-200" data-id="element-5415">
                <div className="flex-1" data-id="element-5416">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5417">
                    <span className="font-bold text-sm" data-id="element-5418">
                      {transaction.type}
                    </span>
                    <span className={`px-2 py-0.5 text-xs font-bold ${transaction.status === 'Completed' ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-blue-50 text-blue-700 border border-blue-200'}`} data-id="element-5419">
                      {transaction.status}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-5420">
                    {transaction.property}
                  </p>
                  <div className="flex items-center gap-4 mt-1 text-xs text-gray-500" data-id="element-5421">
                    <span data-id="element-5422">{transaction.date}</span>
                    {transaction.amount !== '-' && <span data-id="element-5423">{transaction.amount}</span>}
                  </div>
                </div>
                <Link to={`/transaction/${transaction.id}`} className="text-sm text-blue-600 hover:underline" data-id="element-5424">
                  View Details →
                </Link>
              </div>)}
          </div>
        </div>
      </div>
    </DashboardLayout>;
}